// import React from 'react';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend } from 'recharts';
// import { controlData } from '../data/mockData';

// const ControlOps = () => (
//   <div>
//     <h2>Control & Operations</h2>
//     <BarChart width={500} height={300} data={controlData}>
//       <XAxis dataKey="name" />
//       <YAxis />
//       <Tooltip />
//       <Legend />
//       <Bar dataKey="value" fill="#FF8042" />
//     </BarChart>
//   </div>
// );

// export default ControlOps;

import React from 'react';
import {
  BarChart, Bar,
  XAxis, YAxis,
  CartesianGrid, Tooltip, Legend,
  ResponsiveContainer, Cell,
  PieChart, Pie,
  RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar
} from 'recharts';

import {
  controlData,
  scamTypesData,
  targetCountriesData,
  debtBondageData,
  languagesData,
  COLORS
} from '../data/mockData';

const Control = () => {
  return (
    <div className="space-y-6">
      
      {/* Control Mechanisms */}
      <div className="bg-white p-4 rounded shadow">
        <h3 className="font-semibold mb-2">Control Mechanisms</h3>
        <div style={{ width: '100%', height: 300 }}>
          <ResponsiveContainer>
            <BarChart layout="vertical" data={controlData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" />
              <YAxis type="category" dataKey="name" />
              <Tooltip />
              <Bar dataKey="value" fill="#8884d8" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Scam Types and Target Countries */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        
        {/* Types of Scams (Radar) */}
        <div className="bg-white p-4 rounded shadow">
          <h3 className="font-semibold mb-2">Types of Scams</h3>
          <div style={{ width: '100%', height: 300 }}>
            <ResponsiveContainer>
              <RadarChart cx="50%" cy="50%" outerRadius="80%" data={scamTypesData}>
                <PolarGrid />
                <PolarAngleAxis dataKey="subject" />
                <PolarRadiusAxis angle={30} domain={[0, 100]} />
                <Radar name="Scam Type" dataKey="A" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
                <Tooltip />
              </RadarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Target Countries */}
        <div className="bg-white p-4 rounded shadow">
          <h3 className="font-semibold mb-2">Target Countries</h3>
          <div style={{ width: '100%', height: 300 }}>
            <ResponsiveContainer>
              <BarChart data={targetCountriesData} margin={{ bottom: 40 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" angle={-45} textAnchor="end" interval={0} />
                <YAxis />
                <Tooltip />
                <Bar dataKey="value" fill="#8884d8" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Debt Bondage and Languages */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        
        {/* Debt Bondage */}
        <div className="bg-white p-4 rounded shadow">
          <h3 className="font-semibold mb-2">Debt Bondage Amounts</h3>
          <div style={{ width: '100%', height: 300 }}>
            <ResponsiveContainer>
              <BarChart data={debtBondageData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="value" fill="#FF8042" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Languages Used */}
        <div className="bg-white p-4 rounded shadow">
          <h3 className="font-semibold mb-2">Languages Used in Scams</h3>
          <div style={{ width: '100%', height: 300 }}>
            <ResponsiveContainer>
              <PieChart>
                <Pie
                  data={languagesData}
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                  label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                >
                  {languagesData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Control;